import constants from 'core/constants/Constants';
import dayjs from 'dayjs';

export default function disabledDate(current, rangeDate) {
  // Disable days before start date and after end date
  const endDate = rangeDate[1]; // Use end date as is
  const startDate = rangeDate[0]; // Use start date as is
  return (
    current &&
    (current.isBefore(startDate, 'day') || current.isAfter(endDate, 'day'))
  );
}

export function disabledSpecificDate(current, specificDates, allowedYear) {
  return specificDates?.some(
    (date) =>
      current &&
      (current.year() !== Number(allowedYear) ||
        current?.isSame(
          dayjs(date?.holiday_date, constants.DMYFormatWithHyphen),
          'day'
        ))
  );
}
